import { useState, useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { ROUTES } from '@constants'
import images from '@assets/images'
import './Navbar.css'

const NAV_ITEMS = [
  { label: 'Tổng Quan', path: ROUTES.HOME },
  { label: 'Mặt Bằng',  path: ROUTES.MAT_BANG },
  { label: 'Tiện Ích',  path: ROUTES.TIEN_ICH },
  { label: 'Gallery',   path: ROUTES.GALLERY },
  { label: 'Brochure',  path: ROUTES.BROCHURE },
]

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()
  const closeMenu = () => setIsMenuOpen(false)

  // Lock body scroll while drawer is open
  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [isMenuOpen])

  // Close drawer on route change (back/forward navigation)
  useEffect(() => { closeMenu() }, [location.pathname])

  return (
    <>
      <nav className="navbar" role="navigation" aria-label="Main navigation">
        {/* Logo */}
        <NavLink to={ROUTES.HOME} className="navbar__logo" aria-label="Fenica – Trang chủ" onClick={closeMenu}>
          <img src={images.logo} alt="Fenica Logo" />
        </NavLink>

        {/* Desktop menu — hidden ≤1024px via CSS */}
        <ul className="navbar__menu" role="list">
          {NAV_ITEMS.map(({ label, path }) => (
            <li key={path} className="navbar__item">
              <NavLink
                to={path}
                end={path === ROUTES.HOME}
                className={({ isActive }) =>
                  `navbar__link${isActive ? ' navbar__link--active' : ''}`
                }
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Hamburger — visible on mobile (≤640px) via CSS, animated 3-bar → X */}
        <button
          className={`navbar__hamburger${isMenuOpen ? ' navbar__hamburger--open' : ''}`}
          aria-label={isMenuOpen ? 'Đóng menu' : 'Mở menu'}
          aria-expanded={isMenuOpen}
          type="button"
          onClick={() => setIsMenuOpen(v => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* Drawer — sibling of nav so position: fixed stays in root stacking context */}
      <div
        className={`navbar__drawer${isMenuOpen ? ' navbar__drawer--open' : ''}`}
        aria-hidden={!isMenuOpen}
      >
        <ul className="navbar__drawer-list" role="list">
          {NAV_ITEMS.map(({ label, path }) => (
            <li key={path} className="navbar__drawer-item">
              <NavLink
                to={path}
                end={path === ROUTES.HOME}
                className={({ isActive }) =>
                  `navbar__drawer-link${isActive ? ' navbar__drawer-link--active' : ''}`
                }
                onClick={closeMenu}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
        <p className="navbar__signature">© 2026 Fenica. All rights reserved.</p>
      </div>

      {/* Backdrop — tap to close drawer */}
      {isMenuOpen && (
        <div className="navbar__backdrop" onClick={closeMenu} aria-hidden="true" />
      )}
    </>
  )
}

export default Navbar
